/** @format */
import { DateHelperTs } from './DateHelperTs';

export const BILLING_CONSTANTS = {
    IS_INCOME: 'INC',
    IS_ROAM: 'ROAM',
};

export const POSSIBLE_ZONES = {
    ZONE_1: '1',
    ZONE_2: '2',
    EU: 'EU',
};

export const BILLINGS_EVENT_CONSTANTS = {
    SMS: 'SMS',
    SMS_PREMIUM: 'SMS_PREMIUM',
    MMS: 'MMS',
    MMS_PREMIUM: 'MMS_PREMIUM',
    DATA: 'DATA',
    CONVERSATION: 'CONVERSATION',
    CONVERSATION_PREMIUM: 'CONVERSATION_PREMIUM',
    FORWARD1: 'FORWARD1',
    FORWARD2: 'FORWARD2',
};

export const BILLING_EVENT_IDS = {
    SUBSCRIBE: 1,
    VOICE: 2,
    DATA: 3,
    MMS: 4,
    SMS: 5,
};

export const BILLINGS_READABLE_CONSTANTS = {
    SMS: 'SMS',
    MMS: 'MMS',
    DATA: 'Transmisja danych',
    CONVERSATION: 'Rozmowa',
};

export const billingTypes = [
    { value: BILLINGS_EVENT_CONSTANTS.SMS, name: BILLINGS_EVENT_CONSTANTS.SMS },
    { value: BILLINGS_EVENT_CONSTANTS.MMS, name: BILLINGS_EVENT_CONSTANTS.MMS },
    { value: BILLINGS_EVENT_CONSTANTS.DATA, name: BILLINGS_EVENT_CONSTANTS.DATA },
    { value: BILLINGS_EVENT_CONSTANTS.CONVERSATION, name: BILLINGS_EVENT_CONSTANTS.CONVERSATION },
];

export const POSSIBLE_PREFIX = {
    INC_ROAM_SMS_PL_PL: 'INC_ROAM_SMS_PL_PL',
    INC_ROAM_SMS_EU_PL: 'INC_ROAM_SMS_EU_PL',
    INC_ROAM_SMS_PL_EU: 'INC_ROAM_SMS_PL_EU',
    INC_ROAM_SMS_EU_EU: 'INC_ROAM_SMS_EU_EU',
    INC_ROAM_MMS_PL_PL: 'INC_ROAM_MMS_PL_PL',
    INC_ROAM_MMS_EU_PL: 'INC_ROAM_MMS_EU_PL',
    INC_ROAM_MMS_PL_EU: 'INC_ROAM_MMS_PL_EU',
    INC_ROAM_MMS_EU_EU: 'INC_ROAM_MMS_EU_EU',
    ROAM_SMS_PL_PL: 'ROAM_SMS_PL_PL',
    ROAM_SMS_EU_PL: 'ROAM_SMS_EU_PL',
    ROAM_SMS_PL_EU: 'ROAM_SMS_PL_EU',
    ROAM_MMS_PL_EU: 'ROAM_MMS_PL_EU',
    ROAM_MMS_PL_PL: 'ROAM_MMS_PL_PL',
    ROAM_DATA_EU_: 'ROAM_DATA_EU_',
    ROAM_SMS_1_1: 'ROAM_SMS_1_1',
    ROAM_SMS_1_PL: 'ROAM_SMS_1_PL',
    ROAM_SMS_2_EU: 'ROAM_SMS_2_EU',
    ROAM_SMS_2_PL: 'ROAM_SMS_2_PL',
    ROAM_SMS_EU_1: 'ROAM_SMS_EU_1',
    ROAM_SMS_EU_2: 'ROAM_SMS_EU_2',
    INC_SMS: 'INC_SMS',
    INC_MMS: 'INC_MMS',
    SMS: 'SMS',
    MMS: 'MMS',
    DATA: 'DATA',
};

export const checkRoamingZone = (src: string): string | void => {
    if (src.includes(BILLING_CONSTANTS.IS_ROAM)) {
        if (src.includes(POSSIBLE_ZONES.ZONE_1)) {
            return 'Strefa 1';
        }
        if (src.includes(POSSIBLE_ZONES.ZONE_2)) {
            return 'Strefa 2';
        }
        if (src.includes(POSSIBLE_ZONES.EU)) {
            return 'Strefa europejska';
        }
    }
};

export const checkDestination = (src: string): boolean => {
    return src.includes(BILLING_CONSTANTS.IS_INCOME);
};

export const checkEvent = (src: string): string => {
    if (src.includes(BILLINGS_EVENT_CONSTANTS.SMS)) {
        return BILLINGS_READABLE_CONSTANTS.SMS;
    } else if (src.includes(BILLINGS_EVENT_CONSTANTS.MMS)) {
        return BILLINGS_READABLE_CONSTANTS.MMS;
    } else if (src.includes(BILLINGS_EVENT_CONSTANTS.DATA)) {
        return BILLINGS_READABLE_CONSTANTS.DATA;
    } else {
        return BILLINGS_READABLE_CONSTANTS.CONVERSATION;
    }
};

export const checkEventForCount = (type: number, billsec: number): any => {
    if (checkEvent2(type) === BILLINGS_EVENT_CONSTANTS.SMS) {
        return billsec;
    } else if (checkEvent2(type) === BILLINGS_EVENT_CONSTANTS.MMS) {
        return billsec;
    } else if (checkEvent2(type) === BILLINGS_EVENT_CONSTANTS.DATA) {
        return calculateDataTransfer(billsec);
    } else if (checkEvent2(type) === BILLINGS_EVENT_CONSTANTS.SMS_PREMIUM) {
        return billsec;
    } else if (checkEvent2(type) === BILLINGS_EVENT_CONSTANTS.MMS_PREMIUM) {
        return billsec;
    } else if (checkEvent2(type) === BILLINGS_EVENT_CONSTANTS.CONVERSATION_PREMIUM) {
        return DateHelperTs.parseTimeFromSec(billsec);
    } else {
        return DateHelperTs.parseTimeFromSec(billsec);
    }
};

export const checkTargetNumber = (loggedNumber: string, realDst: string, realSrc: string): string => {
    if (loggedNumber.includes(realDst)) {
        return realSrc;
    } else {
        return realDst;
    }
};

export const checkIfRoaming = (src: string): boolean => {
    return src.includes(BILLING_CONSTANTS.IS_ROAM);
};

export const calculateDataTransfer = (transfer: number): string => {
    if (transfer === 0) {
        return `< 1 KB`;
    } else if (!transfer) {
        return '0 KB';
    } else {
        return `${transfer} KB`;
    }
};

// type === 1 ( SUBSCRIBE ) 'Abonament' - nie wyświetlane
export const checkEvent2 = (type: number | null): string | void => {
    if (type !== null) {
        switch (type) {
            case 5:
                return BILLINGS_EVENT_CONSTANTS.SMS;
            case 4:
                return BILLINGS_EVENT_CONSTANTS.MMS;
            case 3:
                return BILLINGS_EVENT_CONSTANTS.DATA;
            case 2:
                return BILLINGS_EVENT_CONSTANTS.CONVERSATION;
            case 6:
                return BILLINGS_EVENT_CONSTANTS.CONVERSATION;
            case 7:
                return BILLINGS_EVENT_CONSTANTS.CONVERSATION;
            case 665:
                return BILLINGS_EVENT_CONSTANTS.MMS_PREMIUM;
            case 666:
                return BILLINGS_EVENT_CONSTANTS.SMS_PREMIUM;
            case 667:
                return BILLINGS_EVENT_CONSTANTS.CONVERSATION_PREMIUM;

            default:
                return '';
        }
    }
};

export const checkEventId = (name: string | null): string | number => {
    if (name !== null) {
        switch (name) {
            case BILLINGS_EVENT_CONSTANTS.SMS:
                return 5;
            case BILLINGS_EVENT_CONSTANTS.MMS:
                return 4;
            case BILLINGS_EVENT_CONSTANTS.DATA:
                return 3;
            case BILLINGS_EVENT_CONSTANTS.CONVERSATION:
                return 2;
            case BILLINGS_EVENT_CONSTANTS.FORWARD1:
                return 6;
            case BILLINGS_EVENT_CONSTANTS.FORWARD2:
                return 7;
            case BILLINGS_EVENT_CONSTANTS.MMS_PREMIUM:
                return 665;
            case BILLINGS_EVENT_CONSTANTS.SMS_PREMIUM:
                return 666;
            case BILLINGS_EVENT_CONSTANTS.CONVERSATION_PREMIUM:
                return 667;
            default:
                return '';
        }
    }
    return '';
};
